import { FC, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  selectedTeacherDashboardFilter,
  setTeacherDashboardFilter,
} from '../../redux/reducers/teacherDashboardFiltersSlice';
import { useGlobalSiteFilter } from '../../custom-hooks/useGlobalSiteFilter';
import { selectedReportsFilter, setReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { useGetClassesByRole } from '../../custom-hooks/useGetClassesByRole';
import { Class } from '../../models/Class';

const GlobalSiteFilterSync: FC = () => {
  const dispatch = useAppDispatch();
  const { selectedSites } = useGlobalSiteFilter();
  const { allClassesData } = useGetClassesByRole(true, true);
  const dashboardFilter = useAppSelector(selectedTeacherDashboardFilter);
  const reportsFilter = useAppSelector(selectedReportsFilter);

  const dashboardFilterRef = useRef(dashboardFilter);
  dashboardFilterRef.current = dashboardFilter;
  const reportsFilterRef = useRef(reportsFilter);
  reportsFilterRef.current = reportsFilter;

  useEffect(() => {
    const sites = selectedSites.map(site => ({ id: site.id, name: site.name }));
    const current = dashboardFilterRef.current;
    const unchanged =
      current.sites?.length === sites.length && sites.every((site, i) => current.sites?.[i]?.id === site.id);

    if (unchanged) return;

    dispatch(setTeacherDashboardFilter({ ...current, sites }));
  }, [selectedSites, dispatch]);

  useEffect(() => {
    const site = dashboardFilter.sites?.[0] ?? { id: '', name: '' };
    const picked = dashboardFilter.classes ?? [];
    const everyClassInSite = allClassesData.filter(cl => !site.id || cl?.site?.id === site.id);
    const classes = (picked.length ? picked : everyClassInSite).map(cl => ({
      id: cl.id,
      name: cl.name,
    })) as Class[];
    const current = reportsFilterRef.current;

    const sameClasses =
      current.classes?.length === classes.length && classes.every((cl, i) => current.classes?.[i]?.id === cl.id);

    if (sameClasses && current.sites?.id === site.id) return;

    dispatch(setReportsFilter({ ...current, classes, sites: site }));
  }, [dashboardFilter, allClassesData, dispatch]);

  return null;
};

export default GlobalSiteFilterSync;
